export type ParsedStrapiError = {
	id: string;
	component: string;
	field: string;
};

export const parseStrapiValidationErrors = (errorMsg: string): ParsedStrapiError[] => {
	if (!errorMsg.includes('[STRAPI_VALIDATION_ERROR]')) return [];

	const cleanMsg = errorMsg.replace('[STRAPI_VALIDATION_ERROR]: ', '').replace(/\s\(at https?:\/\/.*\)$/, '');

	// Split multiple errors if Strapi/GraphQL joins them with ", " or "., "
	const individualErrors = cleanMsg.split(/(?:\.,|,\s*Enum\s+)/).filter(Boolean);

	return individualErrors.map((err, index) => {
		let component = 'Unknown Component';
		let field = '?';
		let fieldPath = '';

		// 1. Check for standard "Cannot return null for non-nullable field Component.attribute"
		const nullMatch = err.match(/field\s+([a-zA-Z0-9_.]+)/);

		// 2. Check for Enum Mismatch "Enum "ENUM_PARTNER_PARTNERCATEGORY" cannot represent value..."
		const enumMatch = err.match(/Enum\s+"([^"]+)"\s+cannot\s+represent\s+value:\s*"([^"]+)"/i);

		if (nullMatch) {
			fieldPath = nullMatch[1];
			const [comp, fld] = fieldPath.split('.');
			component = comp;
			field = fld || '?';
		} else if (enumMatch) {
			const [_, enumName, invalidValue] = enumMatch;
			// Clean up standard Strapi naming conventions (e.g., ENUM_COMP_NAME_FIELD_NAME)
			component = enumName.replace('ENUM_', '').split('_')[0] || 'Enum Schema';
			field = `${enumName.split('_').slice(2).join('_').toLowerCase() || 'value'} ("${invalidValue}" invalid)`;
			fieldPath = enumName;
		} else {
			// Stable fallback if completely unparseable (No Math.random decimals!)
			fieldPath = `unparsed-error-${index}`;
			field = `${err.substring(0, 30)}...`;
		}

		const uniqueId = `${fieldPath}-${index}-${err
			.toLowerCase()
			.replace(/[^a-z0-9]/g, '')
			.substring(0, 15)}`;

		return {
			id: uniqueId,
			component: component,
			field: field
		};
	});
};
